module.exports = {
  src: __webpack_public_path__ + "logo-appstore-it-5f26d8a48ee732dfcf3084327bd82e08.svg",
  width: 119,
  height: 40,
  bytes: 7081,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-appstore-it-5f26d8a48ee732dfcf3084327bd82e08.svg";
};